<template>
  <div class="number-info-content">
    <div class="number-info-input">
      <span>邮箱：</span>
      <a-input
        size="large"
        style="width: 560px"
        v-model="email"
        placeholder="请输入邮箱"
      />
    </div>
    <div class="number-info-input">
      <span>密码：</span>
      <a-input-password
        size="large"
        style="width: 560px"
        v-model="password"
        placeholder="长6-20位且数字、符号、字母至少包含两种"
      />
    </div>
    <div class="number-info-input">
      <span>验证码：</span>
      <a-input
        size="large"
        style="width: 424px"
        v-model="emailVerification"
        placeholder="请输入验证码"
      />
      <div @click="refreshCode">
        <verification :identifyCode="identifyCode" />
      </div>
    </div>
    <div class="number-info-input">
      <span>邮箱验证码：</span>
      <a-input
        size="large"
        style="width: 424px"
        v-model="code"
        placeholder="请输入邮箱验证码"
      />
      <a-button
        @click="emailSmsCode"
        :disabled="emailCodeBtn"
        :class="{ 'btn-gray': emailCodeBtn }"
      >
        {{ emailCodeBtn ? reciprocalNum + "秒后重新发送" : "获取验证码" }}
      </a-button>
    </div>
  </div>
</template>

<script>
import Verification from "@/page/components/verification";
import { registerbyemail, registerSendregistercode } from "@/api/login";
import { validatePwd } from "@/utils/utils";

export default {
  name: "EmailRegister",
  components: { Verification },
  data() {
    return {
      email: "",
      password: "",
      code: "",
      emailVerification: "",
      identifyCodes: "0123456789qwerasdfzxcv",
      identifyCode: "89qw",
      emailCodeBtn: false,
      checkSmsCodeData: {},
      reciprocalNum: 60,
    };
  },
  methods: {
    // 获取邮箱验证码
    emailSmsCode() {
      const { email } = this;
      if (!email) {
        this.$message.warning("* 邮箱不能为空.");
        return;
      }
      if (this.emailVerification !== this.identifyCode) {
        this.$message.warning("* 图形验证码输入有误.");
        return;
      }
      this.emailCodeBtn = true;
      registerSendregistercode({ email }).then((res) => {
        if (res.code !== "0") {
          this.$message.warn(res.msg);
          this.emailCodeBtn = false;
          return;
        }
        this.$message.success("发送成功!");
        this.reciprocalItme();
      });
    },
    reciprocalItme() {
      let num = this.reciprocalNum;
      let itme = setInterval(() => {
        num--;
        if (num <= 0) {
          this.emailCodeBtn = false;
          this.phoneCodeBtn = false;
          this.reciprocalNum = 60;
          clearInterval(itme);
          return;
        }
        this.reciprocalNum = num;
      }, 1000);
    },
    // 刷新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 验证码处理
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    submit() {
      if (!this.email) {
        this.$message.warning("* 邮箱不能为空.");
        return;
      }
      if (this.emailVerification !== this.identifyCode) {
        this.$message.warning("* 图形验证码输入有误.");
        return;
      }
      if (!this.password) {
        this.$message.warning("* 密码不能为空.");
        return;
      }
      if (this.password.length < 6 || this.password.length > 20) {
        this.$message.warning("* 密码长度必须是6-20位.");
        return;
      }
      if (!validatePwd(this.password)) {
        this.$message.warning("* 密码不符合要求.");
        return;
      }
      if (!this.code) {
        this.$message.warning("* 邮箱验证码不能为空.");
        return;
      }
      let data = {
        email: this.email,
        code: this.code,
        password: this.password,
      };
      if (this.checkSmsCodeData.jfId) {
        this.$emit("success", this.checkSmsCodeData);
      } else {
        registerbyemail(data)
          .then((res) => {
            if (res.code !== "0") {
              this.$message.warn(res.msg);
              return;
            }
            this.checkSmsCodeData = res.data;
            this.$store
              .dispatch("Login", {
                username: this.email,
                password: this.password,
                grant_type: "password",
                scope: "server",
                type: "password",
              })
              .then(() => {
                this.$store.dispatch("GetInfo").then(() => {
                  this.$emit("success", this.checkSmsCodeData);
                });
              });
          })
          .catch((e) => {
            this.$message.warn(e.msg);
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.number-info-content {
  height: 456px;
  padding-top: 40px;

  .number-info-input {
    display: flex;
    margin-bottom: 32px;
    justify-content: space-between;

    > span {
      width: 90px;
      line-height: 40px;
    }

    > button {
      width: 120px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      color: #1abc9c;
    }
  }
}
</style>
